export enum ApiResourceStatus {
  Stopped,
  Pending,
  Found,
  NotFound,
  ServerError,
  ClientError,
}

export interface PaginationMetadata {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export {
  type CountryCode,
  type CountryInfo,
  COUNTRY_DICT,
  COUNTRY_LIST,
  DEFAULT_COUNTRY,
  DEFAULT_COUNTRY_CODE,
} from "@topi/domain/country";

/**
 * Transform a float number representing an amount in a currency to equivalent in cents.
 * Alternative could be to use https://mikemcl.github.io/decimal.js/
 * @param x
 */
export function financialCents(x: number): number {
  const inCents = (x * 100).toFixed(0);
  return Number.parseInt(inCents, 10);
}

export type TermsAndConditionsUrls = {
  certifiedDataDeletionService: string;
  demoFirstPartyService: string;
  lissa: string;
  privacyPolicy: string;
  purchase: string;
  rent: string;
  servicesComspot: string;
  servicesComputerhaus: string;
  servicesImplementIt: string;
  servicesInnovazy: string;
  servicesMcshark: string;
  termsOfUse: string;
  topiCare: string;
  topiCarePlus: string;
  topiCarePlusMichaelAG: string;
  topiCarePlusSynaxon: string;
};

export { Currency, mapCurrency } from "@topi/domain/currency";
